











































import { Component, Vue, Prop, Watch, Ref } from "vue-property-decorator";
import ClickOutside from "@/directives/ClickOutside";
import VIcon from "@/components/VIcon.vue";

export interface VSearchInputResult {
  text: string;
  // eslint-disable-next-line
  value: any;
}

enum VSearchInputStatus {
  Idle,
  Searching,
  Searched,
  Error,
}

export class VSearchInputState {
  protected state: VSearchInputStatus = VSearchInputStatus.Idle;
  protected results: VSearchInputResult[] = [];

  get isSearching(): boolean {
    return this.state === VSearchInputStatus.Searching;
  }

  get isSearched(): boolean {
    return this.state === VSearchInputStatus.Searched;
  }

  get isError(): boolean {
    return this.state === VSearchInputStatus.Error;
  }

  get isIdle(): boolean {
    return this.state === VSearchInputStatus.Idle;
  }

  get searchResults(): VSearchInputResult[] {
    return this.results;
  }

  public searching() {
    this.state = VSearchInputStatus.Searching;
  }

  public searched(results: VSearchInputResult[]) {
    this.results = results;
    this.state = VSearchInputStatus.Searched;
  }

  public clear() {
    this.state = VSearchInputStatus.Idle;
    this.results = [];
  }
}

export const VSearchInputDefaults = {
  min: 3,
  delay: 750,
  icon: "search",
};

@Component({
  directives: { ClickOutside },
  components: { VIcon },
})
export default class VSearchInput extends Vue {
  @Prop() readonly placeholder?: string;
  @Prop({ default: VSearchInputDefaults.min }) readonly min!: number;
  @Prop({ default: VSearchInputDefaults.delay }) readonly delay!: number;
  @Prop({ default: VSearchInputDefaults.icon }) readonly icon!: string;

  @Ref() readonly input!: HTMLInputElement;

  protected term = "";
  protected timeout: number | undefined;
  protected dropdownVisible = false;

  protected state = new VSearchInputState();

  @Watch("state.isSearched")
  onSearched(value: boolean) {
    if (value) {
      this.$nextTick(() => {
        this.input.focus();
        this.showDropdown();
      });
    }
  }

  @Watch("state.isIdle")
  onIdle(value: boolean) {
    if (value) {
      this.hideDropdown();
    }
  }

  get hasSlot() {
    return this.$scopedSlots.default;
  }

  protected onKeyUp() {
    if (this.term.length >= this.min) {
      this.clearTimeout();

      this.timeout = setTimeout(() => {
        this.search();
      }, this.delay);
    } else if (this.term.length === 0) {
      this.state.clear();
    }
  }

  protected onInputClick() {
    if (this.term.length === 0 || this.state.isSearching) {
      return;
    }

    if (this.state.searchResults.length) {
      this.showDropdown();
    } else {
      this.search();
    }
  }

  protected clearTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  search() {
    const term = this.term.trim();

    if (term.length < this.min) {
      return;
    }

    this.hideDropdown();
    this.state.searching();
    this.$emit("search", term, this.state);
  }

  clear() {
    this.term = "";
    this.state.clear();
    this.$emit("cleared");
  }

  protected select(item: VSearchInputResult, index: number) {
    this.$emit("selected", item, index);
    this.hideDropdown();
  }

  public showDropdown() {
    this.dropdownVisible = true;
  }

  public hideDropdown() {
    this.dropdownVisible = false;
  }

  protected onClickOutside() {
    this.hideDropdown();
  }
}
